export function restoreCasingInHighlight(highlightStr: string, sourceValue: string): string {
	const plainLower = highlightStr.replace(/<\/?em>/g, '').toLowerCase();
	if (plainLower !== sourceValue.toLowerCase()) {
		return highlightStr;
	}

	let result = '';
	let sourceIdx = 0;
	let charIdx = 0;

	while (charIdx < highlightStr.length) {
		if (highlightStr.startsWith('<em>', charIdx)) {
			result += '<em>';
			charIdx += 4;
		} else if (highlightStr.startsWith('</em>', charIdx)) {
			result += '</em>';
			charIdx += 5;
		} else {
			result += sourceValue[sourceIdx];
			sourceIdx++;
			charIdx++;
		}
	}

	return result;
}
